import { _pHttp } from "../_pHttp";
import { SingleWomanFancard } from "./womenFanCard.types";

export const getWomenFanCard = async (
  page: number,
  search: string,
  filter: string,
  numberInPage: number,
  orderby
) => {
  const { data } = await _pHttp.get(
    `fan-cards?page=${page}&search=${search}&filter=${filter}&numberInPage=${numberInPage}&orderby=${orderby}`
  );
  return data;
};

export const createWomenFanCard = async (body: any) => {
  const { data } = await _pHttp.post(`fan-cards/create`, body);
  return data;
};

export const updateWomenFanCard = async (id: string, body: any) => {
  return await _pHttp.put(`/fan-cards/${id}/status`, body);
};

export const getUserWomenFanCard = async (id: string) => {
  const { data } = await _pHttp.get(`fan-cards/user/${id}`);
  return data;
};

export const getWomenFanCardReports = async () => {
  const { data } = await _pHttp.get(`fan-cards/report-data`);
  return data;
};

export const getSingleWomanFanCard = async (
  userId: string
): Promise<SingleWomanFancard> => {
  const { data } = await _pHttp.get<SingleWomanFancard>(
    `/fan-cards/user/${userId}`
  );
  return data;
};

export const getWomenFanCardExcelReport = async () => {
  try {
    const response = await _pHttp.get(`fan-cards/report`, {
      responseType: "arraybuffer",
    });
    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `fan-cards-report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
